module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "GFP_Part_H1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("Autumn")]), _vm._v(" "), _c('p', {
    staticClass: "GFP_Headnote"
  }, [_c('span', {
    staticClass: "headnote_dropcap"
  }, [_vm._v("A")]), _vm._v("utumn is a season of preparation on the farm: it’s the time we get the flock ready for the next year’s lambing, buy new lambs to replace elderly ewes, sell our ‘fat lambs’ at market, plough and drill our crops for next spring . . . and repair endless fences ready for winter.")]), _vm._v(" "), _c('div', {
    staticClass: "image_fleuron"
  }, [_c('img', {
    staticClass: "image_fleuron",
    attrs: {
      "alt": "fleuron",
      "src": "image/fleuron.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48a6aa6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter.vue
// module id = 75
// module chunks = 0